<template>
  <div class="sm:col-span-2">

    <dl class="mb-5">
        <dt class="text-sm font-medium text-gray-500 sr-only">
          Attachments
        </dt>
        <dd class="mt-1 text-sm text-gray-900">
          <ul role="list" class="border-0 border-gray-200 rounded-md divide-y divide-gray-200">
            <li v-for="(attachment, idx) in attachments"
                :key="`attachment-${idx}`"
                class="pr-4 py-3 flex items-center justify-between text-sm">
              <div class="w-0 flex-1 flex items-center">
                <PaperClipIcon class="flex-shrink-0 h-5 w-5 text-gray-400 transform rotate-45" aria-hidden="true"/>
                <span class="ml-2 flex-1 w-0 truncate"
                      :title="'Uploaded at ' + new Date(attachment.createdAt).toLocaleString('en-US', {dateStyle: 'short', timeStyle: 'short'})">{{
                    attachment.name
                  }}</span>
              </div>
              <div class="ml-4 flex-shrink-0 flex space-x-3">
                <p class="text-xs hidden xl:block capitalize">{{ attachment.member.uuid === currentMemberProfile.uuid ? 'Me' : attachment.member.shortName }}</p>
                <span class="text-gray-300 hidden xl:inline" aria-hidden="true">|</span>
                <p class="text-xs hidden xl:block">{{ prettyBytes(attachment.bytes) }}</p>
                <span class="text-gray-300 hidden xl:inline" aria-hidden="true">|</span>
                <p class="text-xs hidden xl:block">
                  {{ new Date(attachment.createdAt).toLocaleString('en-US', {dateStyle: "short", timeStyle: "short"}) }}</p>
                <span class="text-gray-300 hidden xl:inline" aria-hidden="true">|</span>
                <button v-if="attachment.mimeType === 'application/pdf'"
                    @click="viewAttachment(attachment)"
                    class="font-semibold text-indigo-600 hover:text-indigo-500"
                    title="View the file">
                  <EyeIcon class="h-5 w-5"></EyeIcon>
                  <span class="sr-only">View</span>
                </button>
                <button v-else
                    @click="openAttachment(attachment)"
                    class="font-semibold text-indigo-600 hover:text-indigo-500"
                    title="Download the file">
                  <DownloadIcon class="h-5 w-5"></DownloadIcon>
                  <span class="sr-only">Download</span>
                </button>
                <span class="text-gray-300" aria-hidden="true">|</span>
                <button v-if="attachment.member.uuid === currentMemberProfile.uuid"
                        @click="removeAttachment($event, attachment)"
                        type="button"
                        title="Remove the attachment"
                        class="font-semibold bg-white rounded-md font-medium text-red-600 hover:text-red-500 focus:outline-none">
                  <XIcon class="h-5 w-5"></XIcon>
                  <span class="sr-only">Remove</span>
                </button>
                <button v-else
                        type="button"
                        disabled="disabled"
                        title="Your are not the owner of this attachment"
                        class="cursor-not-allowed font-semibold bg-white rounded-md font-medium text-gray-500">
                  <XIcon class="h-5 w-5"></XIcon>
                  <span class="sr-only">Remove</span>
                </button>
              </div>
            </li>
            <!--        <li class="pr-4 py-3 flex items-center justify-between text-sm">-->
            <!--          <div class="w-0 flex-1 flex items-center">-->
            <!--            <DocumentIcon class="flex-shrink-0 h-5 w-5 text-gray-400" aria-hidden="true"/>-->
            <!--            <span class="ml-2 flex-1 w-0 truncate">coverletter_back_end_developer.pdf</span>-->
            <!--          </div>-->
            <!--          <div class="ml-4 flex-shrink-0 flex space-x-4">-->
            <!--            <a href="#" class="font-semibold text-indigo-600 hover:text-indigo-500">Download</a>-->
            <!--            <span class="text-gray-300" aria-hidden="true">|</span>-->
            <!--            <button type="button"-->
            <!--                    class="font-semibold bg-white rounded-md font-medium text-red-600 hover:text-red-500 focus:outline-none">-->
            <!--              Remove-->
            <!--            </button>-->
            <!--          </div>-->
            <!--        </li>-->
          </ul>
        </dd>
    </dl>


    <!-- files to upload -->
    <div class="bg-white shadow overflow-hidden sm:rounded-md">
      <ul>
        <li v-for="(file, idx) in files" v-bind:key="idx">
          <div
              class="block hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out">
            <div class="px-4 py-4 sm:px-6">
              <div class="flex items-center justify-between">
                <div class="text-sm leading-5 font-medium text-pink-600 truncate">
                  {{ file.name }} ({{ prettyBytes(file.size) }})
                </div>

                <div class="ml-2 flex-shrink-0 flex">
                  <!--                  <button class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">-->
                  <!--                    Remove-->
                  <!--                  </button>-->
                  <progress max=100 :value="uploadProgress[idx]"></progress>
                  <button
                      @click.stop="removeFile(file)"
                      type="button"
                      class="ml-4 font-semibold rounded-md font-medium text-red-600 hover:text-red-500 focus:outline-none">
                    <XIcon class="h-6 w-6 "></XIcon>
                    <span class="sr-only">Remove file to upload</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div v-cloak
         @drop.prevent="handleDropFilesUpload($event)"
         @dragover.prevent
         @click.stop="$refs['file-upload-input'].click()"
         class="cursor-pointer mt-4 border-2 border-gray-300 border-dashed rounded-md p-2 flex justify-center">
      <div class="flex flex-col items-center space-y-1 text-center">
        <!--        <svg class="mx-auto h-10 w-10 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48"-->
        <!--             aria-hidden="true">-->
        <!--          <path-->
        <!--              d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"-->
        <!--              stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>-->
        <!--        </svg>-->
        <CloudUploadIcon class="mx-auto h-10 w-10 text-gray-400"></CloudUploadIcon>
        <div class="flex text-sm text-gray-600">
          <label for="file-upload-input"
                 @click.stop
                 class="relative cursor-pointer bg-white rounded-md font-medium text-primary-600 hover:text-primary focus-within:outline-none">
            <span>Upload a file</span>
            <input
                id="file-upload-input" name="file-upload-input" ref="file-upload-input"
                type="file"
                class="sr-only"
                multiple
                :accept="getAcceptExtensions"
                @change="handleFilesUpload($event)"/>
          </label>
          <p class="pl-1">or drag and drop</p>
        </div>
        <div class="mt-1 font-normal text-sm text-gray-500">{{ getPermitFileExtensions }} up to
          {{ prettyBytes(maxSizePerFile, 0) }}
        </div>
      </div>
    </div>



    <pdf-viewer v-if="viewPdfSrcFile !== null"
                :src="viewPdfSrcFile"
                :document-name="documentName"
                @close="viewPdfSrcFile = null">

    </pdf-viewer>

    <a ref="openAttachment" class="sr-only" target="_blank" rel="noopener noreferrer nofollow"></a>
  </div>
</template>

<script>
import {DownloadIcon, PaperClipIcon, EyeIcon} from '@heroicons/vue/solid'
import {CloudUploadIcon, DocumentIcon, XIcon} from '@heroicons/vue/outline'
import PdfViewer from "@/components/FileViewer/PdfViewer";
import {mapGetters} from "vuex";

export default {
  name: "CompanyAttachment",
  emits: ['attachments:count', 'attachments:add', 'attachments:remove'],
  components: {
    PdfViewer,
    PaperClipIcon,
    DocumentIcon,
    CloudUploadIcon,
    XIcon,
    DownloadIcon,
    EyeIcon,
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
    allowedExtensions: {
      type: Array,
      default(rawProps) {
        // return ['doc', 'docx', 'wps', 'wks', 'wpd', 'ppt', 'pptx', 'pps', 'xls', 'xlsx', 'odt', 'ods', 'odp', 'pdf', 'tex', 'txt', 'rtf', 'jpg', 'jpeg', 'png']
        return ['pdf']
      },
    },
    maxSizePerFile: {
      type: Number,
      default: 52428800
    },
    maxParallelFilesUpload: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      files: [],
      uploadDragoverTracking: false,
      uploadDragoverEvent: false,
      uploadingFileCount: 0,
      notification: [],
      uploadProgress: [],

      attachments: [],
      downloadLinks: [],

      viewPdfSrcFile: null,
      documentName: null,
    }
  },
  created() {
    this.$store.dispatch('loadAttachments', {
      company: this.$props.company,
    }).then(function (attachments) {
      this.attachments = attachments;
    }.bind(this));
  },
  methods: {
    log(x) {
      console.log(x);
    },
    handleFilesUpload(event) {
      this.handleFiles(event.target.files);
    },
    handleDropFilesUpload(event) {
      let droppedFiles = event.dataTransfer.files;
      if (!droppedFiles) return;

      this.handleFiles(droppedFiles);
    },
    handleFiles(files) {
      ([...files]).forEach(f => {

        if (this.files.find(function (existingFile) {
          return (
              existingFile.name === f.name &&
              existingFile.lastModified === f.lastModified &&
              existingFile.size === f.size &&
              existingFile.type === f.type
          )
        })) {
          this.notification.push({file: f, msg: 'File already exists'});
          this.$store.commit('addNotification', {
            type: 'error',
            title: f.name + ' not uploaded',
            body: 'File already exists',
          });
          return;
        }

        if (!this.isAllowedFile(f)) {
          this.notification.push({file: f, msg: 'Bad extension'});
          this.$store.commit('addNotification', {
            type: 'error',
            title: f.name + ' not uploaded',
            body: 'Bad extension',
          });
          return;
        }

        if (!this.isTooBigFile(f)) {
          this.notification.push({file: f, msg: 'File is too big'});
          this.$store.commit('addNotification', {
            type: 'error',
            title: f.name + ' not uploaded',
            body: 'File is too big',
          });
          return;
        }

        if (!this.isReachedParallelUploading(f)) {
          this.notification.push({file: f, msg: 'Parallel upload limit is reached'});
          this.$store.commit('addNotification', {
            type: 'error',
            title: f.name + ' not uploaded',
            body: 'Parallel upload limit is reached',
          });
          return;
        }

        this.files.push(f);
        this.uploadFile(f, this.files.length - 1)
      });
    },
    isAllowedFile(file) {
      const fileExtension = file.name.split('.').pop();
      return 0 <= this.$props.allowedExtensions.findIndex((e) => fileExtension === e);
    },
    isTooBigFile(file) {
      return file.size <= this.$props.maxSizePerFile;
    },
    isReachedParallelUploading() {
      return this.uploadingFileCount <= this.$props.maxParallelFilesUpload;
    },
    removeFile(file) {
      this.files = this.files.filter(f => {
        return f != file;
      });
    },
    uploadFile(file, idx) {
      // console.log(file);
      // console.log(idx);
      this.uploadingFileCount++;
      this.uploadProgress[idx] = 0;
      // console.log(this.uploadingFileCount);
      this.$store.dispatch("createAttachment", {
        company: this.$props.company,
        uploadProgressCallback: function (percentCompleted) {
          this.uploadProgress[idx] = percentCompleted;
        }.bind(this),
        lastValueCallback: function () {
          return this.uploadProgress[idx];
        }.bind(this),
        fileToUpload: file
      }).then(function (attachment) {
        // console.log(attachment)
        this.uploadingFileCount--;
        this.uploadProgress[idx] = 100;
        if (attachment !== undefined) {
          this.attachments.push(attachment);
          this.attachments = [...this.attachments];
          this.$emit('attachments:add', attachment);
        }
        this.removeFile(file);
      }.bind(this)).catch(function (error) {
        // console.log(error)
        this.uploadingFileCount--;
        this.uploadProgress[idx] = 100;
        this.removeFile(file);
      }.bind(this))
    },

    removeAttachment($event, attachment) {
      this.$store.dispatch("deleteAttachment", attachment).then(function () {
        this.attachments = this.attachments.filter(function (value, index, arr) {
          return value.uuid !== attachment.uuid;
        });
        this.$emit('attachments:remove', attachment);
      }.bind(this));
    },

    openAttachment(attachment) {
      const downloadIndex = this.downloadLinks.findIndex((d) => attachment.uuid === d.attachmentUuid);

      if (downloadIndex !== -1) {
        const expireAt = new Date(this.downloadLinks[downloadIndex].expireAt);
        const nowDate = Date.now();
        if (expireAt.getTime() > nowDate) {
          // window.open(this.downloadLinks[downloadIndex].downloadUrl, '_blank', 'noopener,noreferrer')
          this.$refs.openAttachment.href = this.downloadLinks[downloadIndex].downloadUrl;
          this.$refs.openAttachment.click();
          return;
        }
        this.downloadLinks.splice(downloadIndex, 1);
      }

      this.$store.dispatch("createAttachmentDownload", {
        attachment: attachment
      }).then(function (download) {
        this.downloadLinks.push(download);
        // window.open(download.downloadUrl, '_blank', 'noopener,noreferrer')
        this.$refs.openAttachment.href = download.downloadUrl;
        this.$refs.openAttachment.click();
      }.bind(this));
    },

    viewAttachment(attachment) {
      const downloadIndex = this.downloadLinks.findIndex((d) => attachment.uuid === d.attachmentUuid);

      if (downloadIndex !== -1) {
        const expireAt = new Date(this.downloadLinks[downloadIndex].expireAt);
        const nowDate = Date.now();
        if (expireAt.getTime() > nowDate) {
          // window.open(this.downloadLinks[downloadIndex].downloadUrl, '_blank', 'noopener,noreferrer')
          this.viewPdfSrcFile = this.downloadLinks[downloadIndex].downloadUrl;
          this.documentName = attachment.name;
          return;
        }
        this.downloadLinks.splice(downloadIndex, 1);
      }

      this.$store.dispatch("createAttachmentDownload", {
        attachment: attachment
      }).then(function (download) {
        this.downloadLinks.push(download);
        // window.open(download.downloadUrl, '_blank', 'noopener,noreferrer')
        this.viewPdfSrcFile = download.downloadUrl;
        this.documentName = attachment.name;
      }.bind(this));
    },

    prettyBytes(bytes, decimals, kib, maxUnit) {
      kib = kib || false
      if (bytes === 0) return '0 Bytes'
      if (isNaN(parseFloat(bytes)) && !isFinite(bytes)) return 'Not an number'
      // const k = kib ? 1024 : 1000
      const k = 1024
      const dm = decimals != null && !isNaN(decimals) && decimals >= 0 ? decimals : 2
      const sizes = kib ? ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB', 'BiB'] : ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB', 'BB']
      let i = Math.floor(Math.log(bytes) / Math.log(k))
      if (maxUnit !== undefined) {
        const index = sizes.indexOf(maxUnit)
        if (index !== -1) i = index
      }
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    },
  },
  computed: {
    uploadDisabled() {
      return this.files.length === 0;
    },
    getPermitFileExtensions() {
      return this.allowedExtensions.map(e => '.' + e).join(' ');
    },
    getAcceptExtensions() {
      return this.allowedExtensions.map(e => '.' + e).join(',');
    },

    ...mapGetters({
      currentMemberProfile: 'getCurrentMemberProfile',
    }),
  },

  watch: {
    attachments(newValue, oldValue) {
      this.$emit('attachments:count', this.attachments.length)
    },
  },
}
</script>